module.exports = __webpack_public_path__ + "static/media/suzana-sakic.bdd67080.jpg";